import { API, Auth } from 'aws-amplify';
import * as _ from 'lodash';

import {
    POST_TASK,
    POST_TASK_SUCCESS,
    POST_TASK_ERROR,
    FETCH_TASKS,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAIL,

    FETCH_TASKS_HISTORY,
    FETCH_TASKS_HISTORY_SUCCESS,
    FETCH_TASKS_HISTORY_ERROR
} from '../actions/types'

import {
    PENDING,
    PREPARING,
    ASSIGNING_INSPECTOR,
    WAITING_FOR_QUOTES,
    WAITING_QUOTE_ACCEPTANCE,
    REQUESTING_QUOTES,
    ADVANCE_PAYMENT,
    WORKING,
    COMPLETED,
    PAID
} from '../constants/taskStates'

import { showModal, hideModal } from './'

export const fetchTasks = () => {

    return async (dispatch) => {
        dispatch({ type: FETCH_TASKS, payload: {} })
        let config = {
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
            }
        };

        try {
            const response = await API.get('TasksAPI', '/', config)
            console.log("------ fetchTasks", response)
            if (response.success) {
                dispatch({ type: FETCH_TASKS_SUCCESS, payload: { tasks: response.tasks } })
            } else {
                throw new Error("Internal server error")
            }
        } catch (err) {
            dispatch({ type: FETCH_TASKS_FAIL })
        }
    }
}

// Post new task
export const postTask = (task, history, closeModal, imageUploader) => {

    return async (dispatch) => {
        dispatch({ type: POST_TASK });

        try {
            task.images = await imageUploader.getImageUrls();

            let postData = {
                body: task,
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };

            const response = await API.post('TasksAPI', `/tasks`, postData)
            const success = _.get(response, 'success');
            if (success) {
                dispatch({ type: POST_TASK_SUCCESS, payload: { task } });
                dispatch(showModal({ title: 'Success', body: `Your task was successfully posted to our system, we'll be reviewing it and get back to you soon`, isSuccess: true }))
                history.push(`/dashboard`);
                closeModal()
            } else {
                throw new Error('Post task failed')
            }
        } catch (error) {
            console.log('Error in posting task: ', error)
            dispatch({ type: POST_TASK_ERROR });
            dispatch(showModal({ title: 'Failed', body: 'Requesting service failed. Please try again', isError: true }))
        }
    }
}

// Get tasks history
export const fetchTasksHistory = (companyId, searchTaskType = null, searchTaskDate = null, searchTaskState = null) => {
    return async (dispatch) => {

        dispatch({ type: FETCH_TASKS_HISTORY })

        let config = {
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
            },
            queryStringParameters: { companyId, taskType: searchTaskType === "ALL" ? null : searchTaskType, sortedDate: searchTaskDate, taskState: searchTaskState }
        };

        console.log(config)

        try {
            const response = await API.get('TasksAPI', '/tasks/history', config)

            if (response.success) {
                dispatch({ type: FETCH_TASKS_HISTORY_SUCCESS, payload: { tasks: response.tasks } })
            } else {
                throw new Error("Internal server error")
            }
        } catch (error) {
            console.log('Error in fetching tasks history: ', error)
            dispatch({ type: FETCH_TASKS_HISTORY_ERROR })
        }
    }
}